export namespace MlitType {
  export enum LandPrice {
    Mlit = 0,         // 国土交通省地価公示
    Prefectural = 1,  // 都道府県地価調査
  }
}